import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { createBrowserHistory, History } from 'history';

import { appReducer, AppState } from '../states/appState';
import { viewerReducer, ViewerState } from '../states/viewerState';

export interface ApplicationState {
    appState: AppState;
}

export interface IViewerState {
    viewerState: ViewerState;
}

export interface StoreState {
    appState: AppState;
    viewerState: ViewerState;
}

export const history: History = createBrowserHistory();

const store = createStore(
    combineReducers({
        appState: appReducer,
        viewerState: viewerReducer,
    }),
    applyMiddleware(thunk)
);

store.subscribe(() =>
    console.log(store.getState())
)

export default store;
